import { TweenMax, TimelineLite } from 'gsap';
import ScrollMagic from 'scrollmagic';
import ScrollMagicController from '../class/ScrollMagicController';
import Device from '../Device';
import { _isUndefined } from 'gsap/gsap-core';
import { initSwipers } from '../utils/functions';

class Hook {
	constructor() {
		this.sections = document.querySelectorAll('.hook');
		this.sections.forEach((section) => new Section(section));
	}
}

class Section {
	constructor(section) {
		this.section = section;
		this.slidesContainer = section.querySelector('.hook__slides');
		this.video = this.getActiveVideo();
		this.swiper = initSwipers([section], {
			loop: true,
			autoplay: false,
			slidesPerView: 1,
			centeredSlides: true,
			autoHeight: true,
			on: {
				slideChange: () => {
					if (this.video) this.video.pause();
				},
				slideChangeTransitionEnd: () => {
					this.video = this.getActiveVideo();
					if (this.video && this.video.autoplay) {
						this.video.play();
					}
				},
			},
		});

		this.handleResize();
		this.handleScroll();
	}

	handleResize = () => {
		window.addEventListener('resize', () => {
			if (this.video) {
				this.video.pause();
			}

			this.video = this.getActiveVideo();
			if (this.video.autoplay) {
				this.video.play();
			}
		});
	};

	handleScroll = () => {
		const scene = new ScrollMagic.Scene({
			duration: this.slidesContainer.clientHeight,
			triggerElement: this.slidesContainer,
			reverse: true,
		}).addTo(ScrollMagicController.controller);
		scene.on('enter', () => {
			if (!Device.isMobile() && !Device.isTablet() && this.video && this.video.autoplay) {
				this.video.play();
			}
		});
		scene.on('leave', () => {
			if (!Device.isMobile() && !Device.isTablet() && this.video && this.video.autoplay) {
				this.video.pause();
			}
		});
	};

	getActiveSlide = () => this.section.querySelector('.swiper-slide-active');
	getActiveVideo() {
		const className = Device.isMobile() ? 'video-mobile' : 'video-desktop';
		const activeSlide = this.getActiveSlide();
		const video = activeSlide
			? activeSlide.querySelector(`video.${className}`)
			: this.section.querySelector(`video.${className}`);
		return video ? new Video(video) : null;
	}
}

class Video {
	constructor(video) {
		this.video = video;
		this.container = video.parentElement;
		this.playButton = this.container.querySelector('.hook-video__play');
		this.muteButton = this.container.querySelector('.hook-video__mute');
		this.autoplay = video.dataset.autoplay === 'true';
		this.playing = video.paused;
		this.muted = video.muted;

		this.container.addEventListener('click', () => {
			this.autoplay = !this.playing;
			return this.playing ? this.pause() : this.play();
		});

		this.muteButton.addEventListener('click', (ev) => {
			ev.stopPropagation();
			this.video.muted = !this.muted;
			this.muted = this.video.muted;
			this.muteButton.classList.toggle('disabled');
		});
	}

	hasSound() {
		const video = this.video;
		return (
			video.mozHasAudio ||
			Boolean(video.webkitAudioDecodedByteCount) ||
			Boolean(video.audioTracks && video.audioTracks.length)
		);
	}

	play() {
		this.video.play();
		this.playing = !this.video.paused;
		this.hidePlayButton();
	}

	pause() {
		this.video.pause();
		this.playing = !this.video.paused;
		this.showPlayButton();
	}

	hidePlayButton = () => (this.playButton.style.display = 'none');
	showPlayButton = () => (this.playButton.style.display = 'block');
}

export default Hook;
